// extracted by css-extract-rspack-plugin
export default {"avatar":"avatar__V23hS","avatarImage":"avatarImage__fWlqZ","avatarFallback":"avatarFallback__yM6j7"};